<template>
		<!-- Container-fluid starts-->
		<div class="container-fluid">
            <div class="row col-sm-12">
                <div class="col-sm-6">
                    <div class="row">
                        <h4 class="mb-1 mt-4 ml-3 f-w-600">{{ $t('forecast.titleHalfMonthly') }}</h4>
                        <b-button v-show="process !='add'" pill size="sm" @click="process = 'add' " class="bg-primary mb-2 mt-3 ml-3 ">
                            <span class="f-w-600 text-white" style="font-size: 16px;">{{ $t('forecast.add') }} </span>
                        </b-button>                    
                        <b-col lg="3" class="ml-3 mt-3">
                            <b-form-group
                                :label="$t('refill.filter')"
                                label-for="filter-input"
                                label-cols-sm="3"
                                label-align-sm="right"
                                label-size="sm"
                                class="mb-0"
                            >
                                <b-input-group size="sm">
                                    <b-form-input
                                        id="filter-input"
                                        v-model="filter"
                                        type="search"
                                        :placeholder="$t('refill.typeToSearch')"
                                        class="text-info"
                                        style="font-size: 16px;"
                                    ></b-form-input>
                                    <b-input-group-append>
                                    <b-button size="sm" variant="primary" :disabled="!filter" @click="filter = ''">
                                        {{ $t('refill.clear') }}
                                    </b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col lg="4">
                            <b-form-group
                            v-model="sortDirection"
                            :label="$t('refill.filterOn')"
                            :description= "$t('refill.uncheck')"
                            label-cols-sm="3"
                            label-align-sm="right"
                            label-size="sm"
                            class="mb-0"
                            v-slot="{ ariaDescribedby }"
                            >
                            <b-form-checkbox-group
                                v-model="filterOn"
                                :aria-describedby="ariaDescribedby"
                                class="mt-1 text-info"
                                plain
                            >
                                <b-form-checkbox value="lrs">{{ $t('forecast.lrs') }}</b-form-checkbox>                                                                
                                <b-form-checkbox value="year">{{ $t('forecast.yearBE') }}</b-form-checkbox>
                                <b-form-checkbox value="month">{{ $t('forecast.month') }}</b-form-checkbox>   
                                <!-- <b-form-checkbox value="date">{{ $t('forecast.day') }}</b-form-checkbox>    -->
                            </b-form-checkbox-group>
                            </b-form-group>
                        </b-col>   
                    </div>
                    <b-table
                        sticky-header
                        head-variant="light"
                        table-variant="success"
                        show-empty
                        sort-icon-left
                        stacked="sm"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                        :sort-direction="sortDirection"
                        :filter="filter"
                        :filter-included-fields="filterOn"
                        :items="items"
                        :fields="fields"
                        :current-page="currentPage"
                        :per-page="perPage"
                        @filtered="onFiltered"
                    >
                        <template #cell(forecast)="row" >
                            <b-button size="sm" @click="openModalFile(row.item, row.index, $event.target )" class="m-1">
                                {{ row.item.fcId}}
                            </b-button>
                        </template>
                        <template #cell(action)="row" >
                            <b-button pill size="sm" @click="actEdit(row.item)" class="m-1">
                            <span class="f-w-600" style="font-size: 14px;"> {{ $t('forecast.edit') }}</span>
                            </b-button>
                            <b-button pill variant="danger" size="sm" @click="actDelete(row.item)" class="m-1">
                                <span class="f-w-600" style="font-size: 14px;"> {{ $t('forecast.delete') }}</span>
                            </b-button>
                        </template>
                    </b-table>
                    <b-row>
                        <div class="row col-sm-8 ">
                        <b-col class="my-1 ml-3">
                            <b-pagination
                            v-model="currentPage"
                            :total-rows="totalRows"
                            :per-page="perPage"
                            align="fill"
                            class="my-0"
                            ></b-pagination>
                        </b-col>   
                        <b-col sm="3" md="6" class="my-1">
                            <b-form-group
                            :label= "$t('refill.perPage')"
                            label-for="per-page-select"
                            label-cols-sm="6"
                            label-cols-md="4"
                            label-cols-lg="3"
                            label-align-sm="right"
                            label-size="sm"
                            class="mb-0"
                            >
                            <b-form-select
                                id="per-page-select"
                                v-model="perPage"
                                :options="pageOptions"
                            ></b-form-select>
                            </b-form-group>
                        </b-col>
                        </div>
                    </b-row>
                    <b-modal id="fileUrlModal" :title="$t('forecast.title')" ok-only @hide="resetInfoModal" size="md">
                        <div class="card me-5" style=" width:32rem">
                            <iframe
                                v-if="fileUrlModal"
                                :src="fileUrlModal"
                                width="100%"
                                height="300px"
                                style="border: none; margin-top: 10px;"
                                allow="fullscreen"
                            ></iframe>
                        </div>
                    </b-modal>
                </div>     
                <div v-show="process === 'add'" class="col-sm-6">
                   <div class="col-sm-12">
                        <div class="row">
                            <h4 class="text-primary mt-3">{{ $t('forecast.add') }}</h4>
                            <span class="text-danger" style="font-size: 30px; font-weight: bold; cursor: pointer" @click="process = 'info' ">&times;</span>                            
                        </div>
                        <div class="row">
                            <div class="form-group col-sm-3">
                                <label for="lrs" class="f-w-600" style="font-size: 16px;"  >{{ $t("forecast.lrs") }}</label> 
                                <v-select style="font-size:16px;" v-model="lrs" :options="lrsList" :placeholder="$t('forecast.lrsPh')">                                        
                                </v-select>
                            </div>                        
                            <div class="form-group col-sm-3">
                                <b-form-group :label="`${$t('forecast.halfType')}`" v-slot="{ ariaDescribedby }" class="f-w-600" style="font-size: 16px;" >
                                    <b-form-radio-group
                                        v-model="halfType"
                                        :aria-describedby="ariaDescribedby"
                                        plain
                                        stacked
                                    >
                                        <b-form-radio value="F">{{ $t("forecast.firstHalf") }}</b-form-radio>
                                        <b-form-radio value="L">{{ $t("forecast.lateHalf") }}</b-form-radio>                                        
                                    </b-form-radio-group>
                                </b-form-group>
                            </div> 
                            <div class="form-group col-sm-3">
                                <label for="month" class="f-w-600" style="font-size: 16px;"  >{{ $t("forecast.month") }}</label> 
                                <v-select style="font-size:16px;" v-model="month" :options="monthList" :placeholder="$t('forecast.monthPh')">                                        
                                </v-select>
                            </div>                               
                            <div class="form-group col-sm-3">
                                <label for="year" class="f-w-600" style="font-size: 16px;"  >{{ $t("forecast.yearBE") }}</label> 
                                <v-select style="font-size:16px;" v-model="year" :options="yearList" :placeholder="$t('forecast.yearBEPh')">                                        
                                </v-select>
                            </div>                            
                        </div>
                        <div class="top">  
                            <b-button variant="info"  class="my-2 gradient-rbl" size="md" @click="selectFiles"> {{ $t('forecast.choose') }}</b-button>
                            <input 
                                type="file" 
                                ref="fileInput"
                                accept="application/pdf"                                                                
                                @change="onFileSelected" 
                                style="display: none"
                            >
                        </div>
                        <div class="form-group">
                            <button :disabled="selectedFile == ''" class="btn btn-primary btn-block save-btn" style="font-size:20px" type="button" @click="handleSave">{{ $t('forecast.save') }}</button>
                        </div>    
                   </div>
                    <div class="col-sm-12">
                        <iframe
                            v-if="downloadURL"
                            :src="downloadURL"
                            width="100%"
                            height="600px"
                            style="border: none; margin-top: 20px;"
                            allow="fullscreen"
                        ></iframe>
                        <!-- <button @click="uploadFile" :disabled="!file">Upload PDF</button>
                        <button @click="deleteFile" :disabled="!fileUrl">Delete PDF</button> -->   
                        <p v-if="error" style="color: red">{{ error}}</p>
                    </div>
                </div>
                
                <div v-show="process === 'edit' " class="row col-sm-6">
                        <div class="col-sm-12">
                            <div class="row">
                                <h4 class="text-primary mt-3">{{ $t('forecast.editForecast') }}</h4>
                                <span class="text-danger" style="font-size: 30px; font-weight: bold; cursor: pointer" @click="process = 'info' ">&times;</span>                                
                            </div>
                            <div class="row">
                                <div class="form-group col-sm-3">
                                    <div class="row ml-1" style="font-size: 18px;">
                                        <span class= "text-dark f-w-600 mx-2"> {{$t('forecast.lrs')}} 
                                            <span class= "text-info"> {{ lrsEdit.split("/")[0] }}</span>
                                        </span>
                                       
                                    </div>
                                </div>
                                <div class="form-group col-sm-6" style="font-size: 18px;">
                                    <span class= "text-info">{{$t(`forecast.${halfTypeEdit}`)}}</span> 
                                    <span class= "text-dark f-w-600 ml-3"> 
                                        {{ $t("forecast.mthYrBE")}} :
                                        <span class= "text-info">
                                            
                                            <span>{{monthEdit.split("/")[0]}} / </span> 
                                            <span>{{yearEdit.split("/")[0]}}</span>
                                        </span>
                                    </span>
                                </div>
                            </div>
                            <div class="top">  
                            <b-button variant="info"  class="my-2 gradient-rb" size="md" @click="selectFilesEdit"> {{ $t('forecast.chooseEdit') }}</b-button>
                            <input
                                type="file"
                                ref="fileInputEdit"
                                accept="application/pdf"
                                @change="onFileSelectedEdit"                                                               
                                style="display: none"
                            >
                        </div>
                            <div class="form-group">
                                <button :disabled="selectedFileEdit == ''" class="btn btn-warning btn-block save-btn" style="font-size:20px" type="button" @click="handleSaveEdit">{{ $t('forecast.saveEdit') }}</button>
                            </div>                         
                        </div>
                        <div class="col-sm-12">
                        <iframe
                            v-if="downloadURL_Edit"
                            :src="downloadURL_Edit"
                            width="100%"
                            height="600px"
                            style="border: none; margin-top: 20px;"
                            allow="fullscreen"
                        ></iframe>
                        <!-- <button @click="uploadFile" :disabled="!file">Upload PDF</button>
                        <button @click="deleteFile" :disabled="!fileUrl">Delete PDF</button> -->   
                        <p v-if="errorEdit" style="color: red">{{ error}}</p>
                    </div>

                </div>
 
            </div>
        </div>
        <!-- Container-fluid Ends-->
</template>
<script>

import { ref, uploadBytes,deleteObject,getDownloadURL,  storage, saveWithId , getForecastHalfMthlyTbl , deleteItem ,getDataWithDocId } from "../../firebase"
import  {  month, year }  from "../../constants/hor-th"
import Rasee from '../../data/rasee.json'
export default {
	data(){
		return{
            process : "info",
            exstFcId: '',
            lrsList : [],   
            yearList : [],   
            monthList : [],                           
            fcId : '',   // YYYYMMRS
            year : '',   
            month: '',                          
            halfType: 'N',  
            lrs : '',
            fcIdEdit : '',
            yearEdit : '',   
            monthEdit: '',                          
            halfTypeEdit : 'N',
            lrsEdit : '',
    
            items: [],
            fields: [
                { key: 'lrs', label: this.$t('forecast.lrs'), sortable: true, variant: 'warning'},                 
                { key: 'halfType', label: this.$t('forecast.halfType'), sortable: true,
                    formatter: value => {
                        return this.$t(`forecast.${value}`)
                }},  
                { key: 'month', label: this.$t('forecast.month'), sortable: true},                 
                { key: 'year', label: this.$t('forecast.yearBE'), sortable: true },  
                { key: 'dateTS', label: this.$t('forecast.recordDate'), sortable: true, variant: 'secondary', 
                    formatter: value => {
                        return this.$moment(value).format("DD/MM")+"/"+`${parseInt(this.$moment(value).format("YYYY"))+543}`
                }},   
                { key: 'forecast', label: this.$t('forecast.title'), sortable: true , variant: 'info'},  
                { key: 'action', label: this.$t('forecast.actions'), variant: 'danger'}
            ],
            selectedFile: '',
            downloadURL: '',
            error: '',
            fileUrlModal: '',
            fileUrlModalTitle: '',    
            selectedFileEdit: '',
            downloadURL_Edit: '',
            errorEdit: '',                
            downloadURL_Exst: '',
            totalRows: 1,
            currentPage: 1,
            perPage: 12,
            pageOptions: [12, 20, { value: 100, text: "Show a lot" }],
            sortBy: 'fcId',
            sortDesc: true,
            sortDirection: 'desc',
            filter: null,
            filterOn: [],

		}
	},
    computed: {
        sortOptions() {
        return this.fields
            .filter(f => f.sortable)
            .map(f => {
            return { text: f.label, value: f.key }
            })
        },
    },
	mounted(){
        this.lrsList = this.getLrsThList()
        // this.dayList = day
        this.monthList = month
        this.yearList = this.getYearList()
        this.getForecast()
	},
	methods:{ 
        getLrsThList(){
            let rsThList = Rasee.data.map((doc)=>{
                return doc.rsTH
            })
            // console.log(`rsTH List => ${rsThList}`)
            return rsThList
        }, 
        getYearList(){  // limited list from year now to max.
            let yearNow = `${new Date().getFullYear() + 543 } /${new Date().getFullYear()}`
            let yearNowArrNum = year.indexOf(yearNow)
            return year.slice(yearNowArrNum , year.length)
        },
        async getForecast(){
            await getForecastHalfMthlyTbl( res =>{
                this.items = res
                this.totalRows = res.length
        })
        },
        openModalFile(item, index, button) {
            console.log(`items file url => ${JSON.stringify(item)}`)
            this.fileUrlModal = item.fileUrl
            
            this.fileUrlModalTitle = `${this.$t('forecast.lrs')}: ${item.lrs} - ${item.year} - ${item.month} - ${item.halfType == 'F'? this.$t('forecast.F') : this.$t('forecast.L')}`
            this.$root.$emit('bv::show::modal', "fileUrlModal" , button)
        },
        resetInfoModal() {
            this.fileUrlModalTitle = ''
            this.fileUrlModal = ''
        },
        selectFiles(){
            this.$refs.fileInput.click()
        },
        onFileSelected(event) {
            this.selectedFile = event.target.files[0];
            this.downloadURL = URL.createObjectURL(this.selectedFile)
        },
        async uploadFile() {
            if (this.selectedFile.type !== 'application/pdf') {
                this.error = 'Invalid file type. Please select a PDF file.';
                this.selectedFile = null; // Clear selection
                this.$refs.fileInput.value = ''; // Clear file input visual
                return;
            }
            this.error = null;
            const storageRef = ref(storage, `pdfs/${this.selectedFile.name}`);
            try {
                const snapshot = await uploadBytes(storageRef, this.selectedFile);
                // Once uploadBytes resolves, it means the upload is complete
                const downloadURL = await getDownloadURL(snapshot.ref);
                this.downloadURL = downloadURL;
                console.log('File available at,Add', downloadURL);
                // You can now save this downloadURL to your database (e.g., Firestore)

            } catch (error) {
                console.error('Upload failed:', error);
                this.error = `Upload failed: ${error.message}`;
            }
        },
          
        selectFilesEdit(){
            this.$refs.fileInputEdit.click()
        },
        onFileSelectedEdit(event) {
            this.selectedFileEdit = event.target.files[0];
            this.downloadURL_Edit = URL.createObjectURL(this.selectedFileEdit)
        },

        async uploadFileEdit() {
            if (this.selectedFileEdit.type !== 'application/pdf') {
                this.errorEdit = 'Invalid file type. Please select a PDF file.';
                this.selectedFileEdit = null; // Clear selection
                this.$refs.fileInputEdit.value = ''; // Clear file input visual
                return;
            }
            this.errorEdit = null;
            const storageRef = ref(storage, `pdfs/${this.selectedFileEdit.name}`);
            try {
                const snapshot = await uploadBytes(storageRef, this.selectedFileEdit);
                const downloadURL = await getDownloadURL(snapshot.ref);
                this.downloadURL_Edit = downloadURL;
                console.log('File available at,Edit', downloadURL);

            } catch (error) {
                console.error('Upload failed:', error);
                this.error = `Upload failed: ${error.message}`;
            }
        },
        async deleteFile(fileUrl) {
            try {
                const storageRef = ref(storage, fileUrl);
                deleteObject(storageRef)
            } catch (error) {
                this.$toasted.show( `Action-Delete File(Storage) ERROR: ${error.message}`, {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 15000});  
            }
        },


        onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
        },
        handleHover(hovered) {
            this.isHovered = hovered
        },

        actEdit(item) {
            this.fcIdEdit = item.fcId
            this.yearEdit = item.year
            this.monthEdit = item.month
            this.halfTypeEdit = item.halfType
            this.lrsEdit = item.lrs
            this.downloadURL_Edit = item.fileUrl 
            this.downloadURL_Exst= item.fileUrl
            this.selectedFileEdit = ''   
            this.process = "edit"   // to pop up Update subMenu
        },         
        actDelete(item) {
            this.$bvModal.msgBoxConfirm(this.$t('forecast.confirmDeleteMsg'), {
            title: this.$t('forecast.plsConfirm'),
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'warning',
            okTitle: this.$t('refill.yes'),
            cancelTitle: this.$t('refill.no'),
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
            })
            .then(async(value) => {
                if (value) {
                    await deleteItem( "ForecastHM", item.fcId).then(async()=>{
                        await this.deleteFile(item.fileUrl)
                    })
                    await this.refresh()           
                    this.$toasted.show( this.$t('forecast.deleted'), {theme: 'bubble', type: 'success' , position: 'bottom-center', duration: 5000});  
                } else {
                    return
                }
            })
            .catch(error => {
                this.$toasted.show( `Action-Delete: ${error}`, {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});  
            })
        },    
        async handleSave(){
            let msg = 'completed'
            if (this.lrs ===''){
                msg = 'forecast.lrsMsg'
            } else if (this.year ===''){
                msg = 'forecast.yearBEMsg'
            } else if (this.month ===''){
                msg = 'forecast.monthMsg'
            } else if (this.halfType ===''){
                msg = 'forecast.halfMonthMsg'
            } else if (!this.selectedFile){
                msg = 'forecast.selectPDF1st'
            } else if (this.selectedFile.type !== 'application/pdf'){
                msg = 'forecast.selectPDF'
            }  
            if (msg === 'completed'){
                let yyyy = this.year.split("/")[0]
                let fcId= `${yyyy.trim()}${this.month.split('/')[1]}${this.lrs.split('/')[1]}${this.halfType}` //YYYYMMRS
                console.log(`fcId =>${fcId} - lrs => ${this.lrs}`)            
                await getDataWithDocId("ForecastHM", fcId , async(res)=>{
                    if (res.length != 0) {
                        this.$toasted.show(this.$t('forecast.hadDocMsg'), {theme: 'bubble', position: 'bottom-center', type: 'error' , duration: 5000});   
                    } else {
                        this.uploadFile().then(async ()=>{
                            let payload = {
                                fileUrl : this.downloadURL,
                                ts: new Date().valueOf()
                            }
                            await saveWithId('ForecastHM', fcId, payload)
                            await this.refresh()
                            this.$toasted.show(this.$t('forecast.successSave'), {theme: 'bubble', position: 'bottom-center', type: 'success' , duration: 5000});                                                    
                        })   
                    }
                })                    
               
            }else{
                this.$toasted.show(this.$t(msg), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});     
            }
        },
        async handleSaveEdit(){
            if (this.downloadURL_Exst != this.downloadURL_Edit){
                this.uploadFileEdit().then(async()=>{
                    let payload = {
                        fileUrl : this.downloadURL_Edit,
                        ts: new Date().valueOf()
                    }
                    await saveWithId('ForecastHM', this.fcIdEdit, payload)
                    .then(async()=>{
                        await this.deleteFile(this.downloadURL_Exst) 
                        await this.refreshEdit()
                        this.$toasted.show(this.$t('forecast.successSave'), {theme: 'bubble', position: 'bottom-center', type: 'success' , duration: 5000});                                                    
                    })                    
                })

                // .catch(async()=>{
                //     this.$toasted.show(this.$t('forecast.errorSave'), {theme: 'bubble', position: 'bottom-center', type: 'error' , duration: 5000});    
                // })
            }else{
                this.$toasted.show('No save', {theme: 'bubble', type: 'warning' , position: 'bottom-center', duration: 5000});     
            }
        },

        async refresh(){
            await getForecastHalfMthlyTbl((res)=>{
                this.items = res
                this.totalRows = res.length
                this.fcId=''
                this.year = ''
                this.month = ''
                this.halfType = 'N'
                this.lrs =''     
                this.downloadURL= ''
                this.selectedFile = ''   
                this.process = 'info'  // close update submenu
            })
        },
        async refreshEdit(){
            await getForecastHalfMthlyTbl((res)=>{
                this.items = res
                this.totalRows = res.length
                this.fcIdEdit=''
                this.yearEdit = ''
                this.monthEdit = ''
                this.halfTypeEdit = 'N'
                this.lrsEdit = ''
                this.downloadURL_Edit = ''
                this.selectedFileEdit = ''
                this.process = 'info'  // close update submenu
            })
        },
    }
}
</script>
<style scoped>
.gradient-yg {
  background: linear-gradient(135deg, yellow, green);
}
.gradient-rbl {
  background: linear-gradient(45deg, red, blue);
}
.gradient-rb {
  background: linear-gradient(45deg, red, black);
}.save-btn:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}
</style>